import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { FeaturedCompaniesGridCardStoryblok } from '../../../../types/storyblok';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';
import Link from '../../../../base/Link/Link';
import classNames from 'classnames';

export const FeaturedCompaniesGridCard = ({
  companyName,
  link,
  bkgImage,
  logo,
  childClassName,
}: FeaturedCompaniesGridCardStoryblok) => {
  if (!companyName && !link && !bkgImage && !logo) {
    return null;
  }

  return (
    <Box as="article" overlayOverBkg className={classNames(childClassName)}>
      <Box as="div" className="absolute block h-full w-full">
        <StoryblokImage
          src={bkgImage}
          alt={companyName}
          mode="cover"
          maxWidth={1000}
          className="absolute h-full w-full rounded-md"
        />
        <Box
          as="div"
          className="relative flex h-full flex-col justify-between p-8"
        >
          <StoryblokImage
            src={logo}
            alt={companyName}
            mode="responsive"
            maxWidth={600}
            className="h-10"
            assetClassName="!w-auto"
          />

          <Link href={link} variant="arrow-right" empty />
        </Box>
      </Box>
    </Box>
  );
};

export default FeaturedCompaniesGridCard;
